import {
  ChangeEvent,
  ContentType,
  DocumentData,
  FileEntryBM,
} from '@bm-js/atlascloud-shared'
import Input from './Input'
import { Button, marginOptions } from '@bm-js/atlascloud-ui'
import { useMedia } from '../utils/hooks'
import Select from './Select'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'
import DocumentCard from './DocumentCard'

type Props = {
  content: ContentType<DocumentData>
  setData: (e: ChangeEvent<string | FileEntryBM>) => void
}

const DocumentEditor = ({ content, setData }: Props) => {
  const { closeMediaSelector, openMediaSelector } = useMedia()
  const { tr } = useTr()
  return (
    <>
      <Input
        type='text'
        light
        label={tr(TrKey.documentEditorButtonTextLabel)}
        desc={tr(TrKey.documentEditorButtonTextDescription)}
        name='text'
        value={content.data.text}
        onChange={setData}
        id='text'
        placeholder={tr(TrKey.documentEditorButtonTextPlaceholder)}
      />
      <p className='m0 label'>{tr(TrKey.documentEditorDocumentLabel)}</p>
      {content.data.file?.name ? (
        <DocumentCard className='mb-2' file={content.data.file} />
      ) : (
        <p>{tr(TrKey.documentEditorNoDocumentSelected)}</p>
      )}
      <Button
        className='mbottom1'
        onClick={() => {
          openMediaSelector({
            fileType: 'pdf',
            onSelect: (f) => {
              if (!f) return closeMediaSelector()
              const e = {
                target: { name: 'file', value: f },
              }
              setData(e)
              closeMediaSelector()
            },
          })
        }}
      >
        {content.data.file?.name
          ? tr(TrKey.documentEditorChangeDocument)
          : tr(TrKey.documentEditorSelectDocument)}
      </Button>
      <Select
        light
        label={tr(TrKey.documentEditorMarginBottomLabel)}
        desc={tr(TrKey.documentEditorMarginBottomDescription)}
        id='marginBottom'
        name='marginBottom'
        value={content.data.marginBottom}
        onChange={setData}
      >
        <option value='' disabled>
          {tr(TrKey.documentEditorMarginBottomPlaceholder)}
        </option>
        {marginOptions.map((opt) => (
          <option key={`margin_option_${opt.value}`} value={opt.value}>
            {opt.name}
          </option>
        ))}
      </Select>
    </>
  )
}

export default DocumentEditor
